import React from 'react';
import { DataType, DATA_TYPE_DETAILS } from '../types';

interface DataTypeSelectorProps {
  selected: DataType[];
  onChange: (selected: DataType[]) => void;
  error?: string;
}

function DataTypeSelector({
  selected,
  onChange,
  error,
}: DataTypeSelectorProps) {
  const toggle = (dt: DataType) => {
    if (selected.includes(dt)) {
      onChange(selected.filter((d) => d !== dt));
    } else {
      onChange([...selected, dt]);
    }
  };

  return (
    <div className="pq-field">
      <label className="pq-label">
        Data Types <span className="pq-required">*</span>
      </label>
      <div className="pq-dt-grid">
        {DATA_TYPE_DETAILS.map((dt) => {
          const isActive = selected.includes(dt.key);
          return (
            <button
              key={dt.key}
              type="button"
              className={`pq-dt-card ${isActive ? 'active' : ''}`}
              onClick={() => toggle(dt.key)}
            >
              <span className="pq-dt-icon">{dt.icon}</span>
              <div className="pq-dt-text">
                <span className="pq-dt-label">{dt.label}</span>
                <span className="pq-dt-desc">{dt.description}</span>
              </div>
            </button>
          );
        })}
      </div>
      {error && <span className="pq-error pq-error--animate">{error}</span>}
    </div>
  );
}

export default DataTypeSelector;
